import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';

import VueRouter from 'vue-router'

Vue.use(VueRouter)

import Home from './components/Home.vue';
import NotFound404 from './components/NotFound404.vue';
const routes = [
	{ 
		path: '/', 
		component: Home 
	},

	{
		path: '*',
		component: NotFound404
	}

]

const router = new VueRouter({
	mode: 'history',
	routes
})


var SocialSharing = require('vue-social-sharing');
Vue.use(SocialSharing);

Vue.config.productionTip = false

new Vue({
	router,
	vuetify,
	render: h => h(App)
}).$mount('#app')
